import { render, staticRenderFns } from "./OrderFormDialog.vue?vue&type=template&id=9bd7c52a&scoped=true"
import script from "./OrderFormDialog.vue?vue&type=script&lang=js"
export * from "./OrderFormDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderFormDialog.vue?vue&type=style&index=0&id=9bd7c52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd7c52a",
  null
  
)

export default component.exports